const arrayContains = (
    arr: (string | undefined | null)[] | undefined,
    searchStr?: string | null,
) => {
    if (!Array.isArray(arr) || typeof searchStr !== 'string') return undefined;

    return arr.some(
        (item) => typeof item === 'string'
            && item.trim().toLowerCase() === searchStr.trim().toLowerCase(),
    );
};

export default arrayContains;

export function generateStaticNumberOptions({ options, step = 0.1 }) {
    if (!options?.length) return [];

    const start = Math.min(parseFloat(options[0].label), parseFloat(options.at(-1).label));
    const end = Math.max(parseFloat(options[0].label), parseFloat(options.at(-1).label));
    const ascending = parseFloat(options[0].label) < parseFloat(options.at(-1).label);

    const res: any[] = [];

    for (let v = start; v <= end + 1e-9; v += step) {
        const val = Number(v.toFixed(1));
        const label = val.toFixed(1);
        const id = label.endsWith('.0') ? label.slice(0, -2) : label;

        res.push({ label, id });
    }

    return ascending ? res : res.reverse();
}
